import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { smoothScrollToTop } from 'global/utils/smoothScrollToTop';

const ScrollToTop: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    smoothScrollToTop();
  }, [pathname]);

  return children;
};

export default ScrollToTop;
